<template>
    <div class="list-users" data-infinite-scroll>
        <panel-search @search="search" placeholder="Введите фио, телефон или почту для поиска" class="panel-search-light"></panel-search>

        <table class="table table-striped">
            <thead>
            <tr>
                <th>ФИО</th>
                <th>Логин</th>
                <th>Телефон</th>
                <th>E-mail</th>
                <th>Супервайзер</th>
                <th>Салон</th>
                <th>Работает</th>
                <th>Уволен</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="user in users">
                <td>
                    <a :href="`/users/${user.id}`">{{ user.full_name }}</a>
                </td>
                <td>{{ user.login }}</td>
                <td>{{ user.phone }}</td>
                <td>{{ user.email }}</td>
                <td>{{ (user.salon && user.salon.supervisor) ? user.salon.supervisor.full_name : '' }}</td>
                <td>{{ (user.salon) ? user.salon.name : '' }}</td>
                <td v-if="user.start_salon">{{ user.start_salon | date_format('DD.MM.YYYY HH:mm') }}</td>
                <td v-else></td>
                <td v-if="user.end_salon">{{ user.end_salon | date_format('DD.MM.YYYY HH:mm')}}</td>
                <td v-else></td>
            </tr>
            </tbody>
        </table>

        <button class="load-more" v-if="next_page_url" @click="loadNextPage">Еще</button>
    </div>
</template>

<script>
    import axios from 'axios'
    import _ from 'lodash'
    import 'waypoints/lib/jquery.waypoints.js'

    export default {
        props: {
            activated: {
                default: true,
            },
        },
        data(){
            return {
                q: '',
                loading_next_page: null,
                next_page_url: null,
            }
        },
        asyncComputed: {
            users() {
                return axios
                    .get('/api/users', {
                        params: {
                            q: this.q,
                            activated: this.activated,
                            null_salon_id: false
                        }
                    })
                    .then(({data}) => {
                        this.next_page_url = data.next_page_url
                        return data.data
                    })
            },
        },
        methods: {
            search(q) {
                this.q = q
            },
            loadNextPage() {
                if (!this.loading_next_page) {
                    this.loading_next_page = axios
                        .get(this.next_page_url)
                        .then(({data}) => {
                            this.next_page_url = data.next_page_url
                            this.users = this.users.concat(data.data)
                        })
                        .finally(() => this.loading_next_page = null)
                }
            },
        },
        mounted() {
            // Infinite scroll
            var infContainer = $('[data-infinite-scroll]')
            if (!infContainer.length) return
            var self = this

            infContainer.waypoint({
                handler: function (direction) {
                    if (direction == 'down' && self.next_page_url) {
                        if (this.triggerPoint >= 0) {
                            self.loadNextPage()
                        }
                    }
                },
                offset: 'bottom-in-view'
            })
        }
    }
</script>



// WEBPACK FOOTER //
// ListUsers.vue?5c5a3294